import React from 'react';
import { useCMS } from '../context/CMSContext';
import Meta from '../components/Meta';
import AnimatedSection from '../components/AnimatedSection';

export default function Reference() {
  const { getPage, loading } = useCMS();
  const page = getPage('reference');

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-brand-red border-t-transparent" />
      </div>
    );
  }

  const title = page?.title || "Reference | Chr. Nielsen & Søn V/Leif Nielsen";
  const metaDescription = page?.meta_description || "Se flere af vores projekter og referencer her.";
  const headline = page?.headline || "Reference";
  const contentHtml = page?.content || "";

  return (
    <>
      <Meta title={title} description={metaDescription} pageTitle="Reference" />

      {/* Page Header */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/c3c69980-e6b4-4d46-bdae-26d6f6795887/distribution-danmark.jpg" 
            alt="Reference" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/85" />
          <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent" />
        </div>

        <div className="relative z-10 mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-white uppercase tracking-tight">
            {headline}
          </h1>
          <div className="h-1.5 w-24 bg-brand-red mx-auto mt-6" />
        </div>
      </section>

      {/* Main Content */}
      <section className="pt-10 lg:pt-24 pb-24 bg-brand-dark">
        <div className="mx-auto max-w-[800px] px-4 sm:px-6 lg:px-8 text-left">
          <AnimatedSection direction="up" duration={800}>
            <div className="bg-brand-dark-card border border-brand-dark-border rounded-lg p-8 sm:p-12 shadow-xl space-y-8">
              <div 
                className="prose prose-invert max-w-none text-gray-300 leading-relaxed space-y-6 
                  prose-headings:text-white prose-headings:uppercase prose-headings:tracking-wide prose-headings:font-bold
                  prose-h2:text-lg sm:prose-h2:text-2xl prose-h2:border-l-4 prose-h2:border-brand-red prose-h2:pl-4 prose-h2:mt-8 prose-h2:mb-4
                  prose-h3:text-base sm:prose-h3:text-xl prose-h3:border-l-4 prose-h3:border-brand-green prose-h3:pl-4 prose-h3:mt-6 prose-h3:mb-3"
                dangerouslySetInnerHTML={{ __html: contentHtml }}
              />

              {/* Image from the scrape */}
              <div className="relative aspect-[16/9] rounded-lg overflow-hidden border border-brand-dark-border mt-8">
                <img 
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c3c69980-e6b4-4d46-bdae-26d6f6795887/placeholder.jpg" 
                  alt="Reference" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </>
  );
}
